import * as React from "react";
import { useSelector, useDispatch } from "react-redux";
import { MessageBar, MessageBarType, MessageBarButton } from "@fluentui/react";

import Progress from "./Progress";
import Routes from "./Routes";
import Header from "./components/header/Header";
import { TEXT } from "./shared/constants/texts";
import { ROUTE } from "./shared/constants/routes";
import { AppProps } from "./shared/interface/AppProps";

import {
  storeSingleEmailData,
  hideNotification,
  storeEmailUrlsData,
  enableAdvancePage,
} from "./containers/add-to-ici/redux/slice";
import { addAppValidationMessage } from "./shared/redux/actions";
import { OFFICE_PLATFORMS } from "./shared/constants/officePlatforms";

import SessionService from "./shared/services/sessionService";
const sessionService = new SessionService();

const App: React.FC<AppProps> = (props: AppProps) => {
  const dispatch = useDispatch();
  const { title, isOfficeInitialized } = props;

  const state = useSelector((state: any) => state.addToIciSlice);
  const {
    showNotification,
    notificationType,
    notificationMessage,
    retryActionOnError,
    errMessage,
    errorCode,
    correlationId,
  } = state;

  const [showMoreInfo, setShowMoreInfo] = React.useState(false);
  const previewUrl = window.location.hash;

  React.useEffect(() => {
    dispatch(addAppValidationMessage());
    let url = new URL(window.location.href);
    let addtoici = url.searchParams.get("addtoici");
    if (addtoici) {
      sessionService.setAddToICI(addtoici);
    }
  }, []);

  React.useEffect(() => {
    if (isOfficeInitialized && Office.context.mailbox) {
      Office.context.mailbox.addHandlerAsync(Office.EventType.ItemChanged, handleOfficeItems);
      handleOfficeItems();
    }
  }, [isOfficeInitialized]);

  const handleOfficeItems = () => {
    const mailbox = Office.context.mailbox;
    const item = mailbox.item;
    if (item) {
      dispatch(storeSingleEmailData(item));
    }
    const restUrl = mailbox.restUrl;
    const ewsUrl = mailbox.ewsUrl;
    dispatch(storeEmailUrlsData({ restUrl: restUrl, ewsUrl: ewsUrl }));
    // @ts-ignore
    if (Office.context.platform === OFFICE_PLATFORMS.PC || Office.context.platform === OFFICE_PLATFORMS.MAC) {
      dispatch(enableAdvancePage(false));
    } else {
      dispatch(enableAdvancePage(true));
    }
  };

  if (!isOfficeInitialized) {
    return <Progress title={title} logo="assets/logo-filled.png" message={TEXT.PROGRESS_MESSAGE} />;
  }

  const showMoreInformationClicked = () => {
    setShowMoreInfo(!showMoreInfo);
  };

  const authToken = sessionService.getAuthToken();
  const idpToken = sessionService.getIdpAccessToken();

  return (
    <React.Fragment>
      {(authToken || idpToken) && !previewUrl.includes(ROUTE.PREVIEW) ? <Header /> : null}
      <Routes />
      {showNotification ? (
        <div className="message-bar">
          <MessageBar
            styles={{
              root: {
                height: "auto",
                minHeight: "38px",
                width: "98vw",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
              content: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              },
            }}
            actions={
              notificationType === MessageBarType.error ? (
                <div>
                  <MessageBarButton onClick={() => retryActionOnError()}>{TEXT.RETRY}</MessageBarButton>
                </div>
              ) : null
            }
            messageBarType={notificationType}
            isMultiline={false}
            onDismiss={() => dispatch(hideNotification())}
          >
            {notificationMessage}
            {notificationType === MessageBarType.error && errorCode ? (
              <React.Fragment>
                <p className="more-information" onClick={showMoreInformationClicked}>
                  {!showMoreInfo ? TEXT.MORE_INFORMATION : TEXT.HIDE_INFORMATION}
                </p>
                {showMoreInfo ? (
                  <React.Fragment>
                    {errMessage ? (
                      <p className="msg-error-heading">
                        <span>{errMessage}</span>
                      </p>
                    ) : null}
                    {correlationId ? (
                      <p className="msg-error-heading">
                        <span>CorrelationID - </span>
                        <span className="msg-error-value">{correlationId}</span>
                      </p>
                    ) : null}
                    {errorCode ? (
                      <p className="msg-error-heading">
                        <span>Error Code - </span>
                        <span className="msg-error-value">{errorCode}</span>
                      </p>
                    ) : null}
                  </React.Fragment>
                ) : null}
              </React.Fragment>
            ) : null}
          </MessageBar>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default App;
